import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFluentEmojiFlatFire = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.3122 15.1086C20.3122 19.8742 16.3669 23.7062 11.6013 23.4218C6.70362 23.1297 3.35128 18.4195 3.98253 13.4961C4.36456 10.5015 5.76847 7.93356 7.29659 5.94138C7.56222 5.59372 7.83487 8.39138 8.10753 8.08356C8.38097 7.76716 10.9153 3.38122 11.7966 1.8406C11.8345 1.77264 11.8866 1.71364 11.9493 1.6676C12.012 1.62156 12.0839 1.58956 12.1601 1.57378C12.2363 1.55799 12.315 1.55879 12.3908 1.57611C12.4667 1.59344 12.5379 1.62689 12.5997 1.67419C14.37 3.01013 20.3122 8.0281 20.3122 15.1086Z",
		fill: "#FF6723"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.969 17.0711C17.969 20.2289 15.2198 22.7672 11.8761 22.6523C8.26668 22.5305 5.79168 19.2273 6.32137 15.825C7.08621 10.9469 12.094 7.8125 12.094 7.8125C12.094 7.8125 17.969 11.4898 17.969 17.0711Z",
		fill: "#FFB02E"
	})]
});
export default SvgFluentEmojiFlatFire;
